module.exports = __webpack_public_path__ + "img/bg_9.2e216f63.jpg";